import { ExternalLink } from 'lucide-react';
import { Link } from 'react-router-dom';

import { Modal, ModalContent } from '@sandtech-hub-monorepo/ui-kit';
import { formatDate } from '@sandtech-hub-monorepo/ui-kit-site';

import { ReactComponent as LinkedInIcon } from '../../assets/Icons/linkedin-icon.svg';

export interface ShareDetails {
  title: string;
  /** Tag under the title, e.g. "Course" or "Program". */
  typeLabel: string;
  imageUrl?: string | null;
  earnedAt?: string | null;
  shareUrl: string;
}

interface Props {
  details: ShareDetails;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

/** Confirms what is being shared before handing off to LinkedIn. */
export const ShareBadgeModal = ({ details, open, onOpenChange }: Props) => (
  <Modal open={open} onOpenChange={onOpenChange}>
    <ModalContent title="Share Details" className="rounded-2xl md:w-[418px]">
      <div className="flex flex-col items-start gap-4 text-left">
        <span className="rounded-md bg-success/10 px-2 py-0.5 text-sm text-success">
          Active
        </span>
        <div className="flex w-full gap-6 rounded-lg border border-border p-4">
          {details.imageUrl && (
            <img
              src={details.imageUrl}
              alt=""
              className="h-auto w-20 shrink-0 self-start"
            />
          )}
          <div className="flex min-w-0 flex-col items-start gap-3">
            <p className="text-lg font-semibold text-heading">
              {details.title}
            </p>
            <span className="rounded bg-background px-1.5 py-0.5 text-xs font-medium uppercase text-tertiary">
              {details.typeLabel}
            </span>
            {details.earnedAt && (
              <span className="text-sm text-muted-foreground">
                Earned on {formatDate(details.earnedAt)}
              </span>
            )}
          </div>
        </div>
        <Link
          to={details.shareUrl}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => onOpenChange(false)}
          className="flex w-full items-center gap-4 py-2.5 text-heading"
        >
          <LinkedInIcon className="h-6 w-6 shrink-0 fill-linkedin" />
          <span className="flex-1 font-medium">Share on LinkedIn</span>
          <ExternalLink className="h-6 w-6 shrink-0 text-muted-foreground" />
        </Link>
      </div>
    </ModalContent>
  </Modal>
);
